export const version = "abstract-signer/5.5.0";
//# sourceMappingURL=_version.js.map